import React from "react";
import FormattedMessage from "components/FormattedMessage";
import { Box, Text } from "ui-components";
import PageHeader from "components/PageHeader";

const ScheduleDeliveryStatus = props => {
  return (
    <Box width={[1, 1, 2 / 3]} margin="auto" variant="main" padding="2rem">
      <PageHeader title="replace_with_esim_success" />
      <Text>
        <FormattedMessage
          html
          id="replace_with_esim_success_content"
          values={props}
        />
      </Text>
    </Box>
  );
};

ScheduleDeliveryStatus.defaultProps = {};

export default ScheduleDeliveryStatus;
